import {CSSProperties, Children, FormEvent} from "react";
import {compose} from "redux";
import {connect} from "react-redux";
import {Link} from "react-router";
import AppBar from "material-ui/AppBar";
import {Table, TableBody, TableRow, TableRowColumn} from "material-ui/Table";
import FloatingActionButton from "material-ui/FloatingActionButton";
import FontIcon from "material-ui/FontIcon";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import TextField from "material-ui/TextField";

import {Ganymede} from "@slices/Ganymede/ClientManager";
import {AuthExceptions} from "@slices/AuthExceptions/Exceptions";

import {RootState} from "src/reducers/index";
import {routeComponent, InjectedProps} from "src/utils/router";
import LayoutWithAppBar from "src/components/LayoutWithAppBar";
import {cloneElementWithStyle} from "src/utils/components";

import {
  projectsRoute, createProjectClicked,
  cancelCreateClicked, newProjectNameChanged, createProjectSubmitted,
} from "./Projects.actions";


const styles = {
  createButton: {
    position: 'fixed',
    top: 30,
    right: 28,
    zIndex: 2000,
  },

  createDialog: {
    width: 360,
  },
};


interface ProjectsTableProps {
  projects: Ganymede.Project[];
}

const ProjectsTable = ({
  projects,
}: ProjectsTableProps) => {
  return <Table selectable={false}>
    <TableBody displayRowCheckbox={false}>
      {projects.map(project =>
        <TableRow key={project.id}>
          <TableRowColumn>{project.name}</TableRowColumn>
          <TableRowColumn>
            <Link to={`/projects/${project.id}`}>
              <FontIcon className="material-icons">settings</FontIcon>
            </Link>
          </TableRowColumn>
        </TableRow>)}
    </TableBody>
  </Table>;
};


type ProjectsProps = InjectedProps<{style?: CSSProperties}, {}>;

const Projects = compose(
  routeComponent<{style?: CSSProperties}, {}>(projectsRoute),
  connect(
    (state: RootState, props: ProjectsProps) => {
      return state.routes.projects;
    },
    {
      handleCreateClick() {
        return createProjectClicked();
      },
      handleCancelCreateClick() {
        return cancelCreateClicked();
      },
      handleNameChange(e: any, value: string) {
        return newProjectNameChanged(value);
      },
      handleProjectSubmit(e: FormEvent<any>) {
        e.preventDefault();
        return createProjectSubmitted();
      },
    },
  ),
)(({
  style,
  children,

  projects,
  createDialogOpen,
  isCreating,
  newProjectName,
  createError,

  handleCreateClick,
  handleCancelCreateClick,
  handleNameChange,
  handleProjectSubmit,
}) => {
  if (Children.count(children) > 0)
    return cloneElementWithStyle(Children.only(children), style);

  const appBar = <AppBar title="Projects"
                         showMenuIconButton={false}/>;

  const dialogActions = [
    <FlatButton label="Cancel"
                disabled={isCreating}
                onTouchTap={handleCancelCreateClick}/>,
    <FlatButton label="Create"
                disabled={isCreating || !newProjectName}
                onTouchTap={handleProjectSubmit}/>,
  ];

  const createErrorText = createError && (
    (createError instanceof AuthExceptions.Forbidden) ? 'Forbidden' :
    'Error'
  );

  const dialog = <Dialog title="Create Project"
                         open={createDialogOpen}
                         actions={dialogActions}
                         contentStyle={styles.createDialog}>
    <form onSubmit={handleProjectSubmit}>
      <TextField fullWidth name="name"
                 disabled={isCreating}
                 hintText="Project name"
                 errorText={createErrorText}
                 value={newProjectName}
                 onChange={handleNameChange}/>
    </form>
  </Dialog>;

  return <LayoutWithAppBar style={style} appBarElement={appBar}>
    <div>
      <FloatingActionButton style={styles.createButton} secondary
                            onTouchTap={handleCreateClick}>
        <FontIcon className="material-icons">add</FontIcon>
      </FloatingActionButton>

      {dialog}

      {projects == null ? <div>Loading...</div> :
        projects.length === 0 ? <div>No projects</div> :
          <ProjectsTable projects={projects}/>}
    </div>
  </LayoutWithAppBar>;
});

export default Projects;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/projects/Projects.tsx